//import { TimeZone } from "./TimeZone";

export class SessionInfo {

    private static isUserAuthorized: boolean = false;
    public static get IsUserAuthorized(): boolean { return this.isUserAuthorized; }
    public static set IsUserAuthorized(newValue: boolean) {
        this.isUserAuthorized = newValue;
    }

    private static authorizedUserToken: string | null = null;
    public static get AuthorizedUserToken(): string | null { return this.authorizedUserToken; }
    public static set AuthorizedUserToken(newValue: string | null) {
        this.authorizedUserToken = newValue;
    }

    private static isLogitudeAuthentication: boolean = false;
    public static get IsLogitudeAuthentication(): boolean { return this.isLogitudeAuthentication; }
    public static set IsLogitudeAuthentication(newValue: boolean) {
        this.isLogitudeAuthentication = newValue;
    }

    private static logitudeTokensJson: string | null = null;
    public static get LogitudeTokensJson(): string | null { return this.logitudeTokensJson; }
    public static set LogitudeTokensJson(newValue: string | null) {
        this.logitudeTokensJson = newValue;
    }

    // private static loggedUserId: number;
    // public static get LoggedUserId(): number { return this.loggedUserId; }
    // public static set LoggedUserId(newValue: number) { this.loggedUserId = newValue; }

    // private static loggedUserTenant: number;
    // public static get LoggedUserTenant(): number { return this.loggedUserTenant; }
    // public static set LoggedUserTenant(newValue: number) { this.loggedUserTenant = newValue; }

    // private static loggedUserFirstName: string;
    // public static get LoggedUserFirstName(): string { return this.loggedUserFirstName; }
    // public static set LoggedUserFirstName(newValue: string) { this.loggedUserFirstName = newValue; }

    // private static loggedUserLastName: string;
    // public static get LoggedUserLastName(): string { return this.loggedUserLastName; }
    // public static set LoggedUserLastName(newValue: string) { this.loggedUserLastName = newValue; }

    // private static loggedUserEmail: string;
    // public static get LoggedUserEmail(): string { return this.loggedUserEmail; }
    // public static set LoggedUserEmail(newValue: string) { this.loggedUserEmail = newValue; }

    // private static loggedUserPassword: string;
    // public static get LoggedUserPassword(): string { return this.loggedUserPassword; }
    // public static set LoggedUserPassword(newValue: string) { this.loggedUserPassword = newValue; }

    // private static loggedUserType: number;
    // public static get LoggedUserType(): number { return this.loggedUserType; }
    // public static set LoggedUserType(newValue: number) { this.loggedUserType = newValue; }

    // private static loggedUserTypeCode: string;
    // public static get LoggedUserTypeCode(): string { return this.loggedUserTypeCode; }
    // public static set LoggedUserTypeCode(newValue: string) { this.loggedUserTypeCode = newValue; }

    // private static loggedUserPartnerId: number;
    // public static get LoggedUserPartnerId(): number { return this.loggedUserPartnerId; }
    // public static set LoggedUserPartnerId(newValue: number) { this.loggedUserPartnerId = newValue; }

    // private static loggedUserPartnerExternalId: string;
    // public static get LoggedUserPartnerExternalId(): string { return this.loggedUserPartnerExternalId; }
    // public static set LoggedUserPartnerExternalId(newValue: string) { this.loggedUserPartnerExternalId = newValue; }

    // private static loggedUserTimeZone: TimeZone;
    // public static get LoggedUserTimeZone(): TimeZone { return this.loggedUserTimeZone; }
    // public static set LoggedUserTimeZone(newValue: TimeZone) { this.loggedUserTimeZone = newValue; }

    // private static loggedUserDaylightSavingTime: boolean;
    // public static get LoggedUserDaylightSavingTime(): boolean { return this.loggedUserDaylightSavingTime; }
    // public static set LoggedUserDaylightSavingTime(newValue: boolean) { this.loggedUserDaylightSavingTime = newValue; }
}